import { useState } from "react";
import * as httpService from '../../services/HTTPService';
import { hideOverlay } from "../../utils/utils";
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const CreatePopup = (props: any) => {
    const { t, i18n } = useTranslation();
    const [createValue, setCreateValue] = useState('');
    let [isSpinning, setIsSpinning] = useState(true);
    const user: any = localStorage.getItem('auth-user');
    const authUser = JSON.parse(user);
    const { email } = authUser;
    const moodBoardLbl = i18n.exists("pages.moodboard") ? t('pages.moodboard') : "Moodboard";
    const createLbl = i18n.exists("pages.create") ? t('pages.create') : "Създай";
    const createdSuccessfulLbl = i18n.exists("pages.createdSuccessful") ? t('pages.createdSuccessful',  {value: moodBoardLbl}) : "Бордът е създаден успешно."; 
    const [showCreate, setShowCreate] = useState(false);
    const sectionNameLbl = i18n.exists("pages.sectionNameLbl") ? t('pages.sectionNameLbl') : "Име на борда";

    const onCreateValueChange = (e: any) => {
        setCreateValue(e.target.value);
    }

    const createMoodboard = () => {
        setIsSpinning(true);
        if(createValue.length > 0) {
            //console.log(createValue)
            const body = {
                name: createValue,
                userId: email
            }
            httpService.createMoodboard(body).then((res) => {
                setIsSpinning(false);
                hideOverlay();
                toast.success(createdSuccessfulLbl);
            })
            .catch(err => {
                setIsSpinning(false);
                hideOverlay();
                console.log(err);
                toast.error(t('forms.commonErrMsg'));
            });

            setShowCreate(false);
        }
    }

    const hide = (e: any) => {
        console.log(e.target)
        if(e.target.className === "overlay-out") {
            props.hide(true);
        }
    }

    return (
        <div className="overlay-out" onClick={hide}>
            <div className='create-popup'>
                <h3 className='inter-light'>{sectionNameLbl}</h3>
                <div className='create-popup-in'>
                    <input onChange={onCreateValueChange} type="text" />
                    <div className='align-right'>
                        <button className='btn btn-primary inter-light' onClick={createMoodboard} disabled={createValue === "" ? true : false} >{createLbl}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

    export default CreatePopup;